import { doc, getDoc } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../firebaseConfig";
import appStore from "../assets/images/App-Store.png";
import logo from "../assets/images/BUZD-Logo-Icon-Black.png";
import playStore from "../assets/images/Play-Store.png";
import { useDimensions } from "../hooks";

function Redirect2() {
  const [name, setName] = useState(null);
  const [redirectLink, setRedirectLink] = useState(null);
  const { height } = useDimensions();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    // sender id
    const id = queryParams.get("senderId");
    getSenderName(id);

    // env
    const env = queryParams.get("env");
    if (env === "development") {
      const prefix = queryParams.get("prefix");
      setRedirectLink(`${prefix}referral?senderId=${id}`);
    }
    if (env === "production") {
      setRedirectLink(`buzd://referral?senderId=${id}`);
    }

    return () => {};
  }, []);

  // get sender name from firestore collection Users where uid = senderId
  const getSenderName = async (senderId) => {
    const userRef = doc(db, "Users", senderId);
    const userSnap = await getDoc(userRef);
    const user = userSnap.data();
    setName(`${user.firstName} ${user.lastName}`);
  };

  const text = "If you don't have the Buzd app,\nDownload it here silly goose!";
  const text2 = "Once you've signed up,\nclick the button below to get Buzd!";

  const renderStoreButtons = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          marginTop: height * 0.05,
          justifyContent: "center",
        }}
      >
        {/* APP STORE BUTTON */}
        <a
          href="https://apps.apple.com/us/app/buzd-delivery/id1599830012"
          target="_blank"
          rel="noreferrer"
        >
          <img src={appStore} alt="App Store Button" width={180} height={50} />
        </a>

        {/* JUST FOR SPACING */}
        <div style={{ width: 10 }} />

        {/* PLAY STORE BUTTON */}
        <a
          href="https://play.google.com/store/apps/details?id=com.buzd.android"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={playStore}
            alt="Play Store Button"
            width={180}
            height={50}
          />
        </a>
      </div>
    );
  };

  // render a button that calls the redirect function
  const renderRedirectButton = () => {
    return (
      <a href={redirectLink}>
        <button
          style={{
            cursor: "pointer",
            marginTop: height * 0.04,
            height: 55,
            width: 220,
            color: "white",
            fontSize: 20,
            borderRadius: 7,
            borderWidth: 2,
            borderColor: "white",
            backgroundColor: "black",
          }}
        >
          Redeem Referral
        </button>
      </a>
    );
  };

  return (
    <div style={{ textAlign: "center" }}>
      {/* BACKGROUND COLOR */}
      <div
        style={{
          position: "fixed",
          height: "100vh",
          width: "100vw",
          backgroundColor: "#feda30",
          zIndex: -1,
        }}
      />
      {/* MAIN */}
      <div
        style={{ fontSize: 14, fontWeight: "bold", paddingTop: height * 0.1 }}
      >
        {/* LOGO */}
        <img src={logo} alt="Play Store Button" width={50} height={40} />

        {/* SENDER */}
        {name ? <div>Referred by: {name}</div> : null}

        {/* TEXT */}
        <div
          style={{
            fontSize: 14,
            lineHeight: 0.5,
            fontWeight: "bold",
            marginTop: height * 0.05,
          }}
        >
          {text.split("\n").map((para, index) => (
            <p key={index}>{para}</p>
          ))}
        </div>

        {/* STORE BUTTONS */}
        {renderStoreButtons()}

        {/* TEXT 2 */}
        <div
          style={{
            fontSize: 14,
            lineHeight: 0.5,
            fontWeight: "bold",
            marginTop: height * 0.05,
          }}
        >
          {text2.split("\n").map((para, index) => (
            <p key={index}>{para}</p>
          ))}
        </div>

        {/* REDIRECT BUTTON */}
        {redirectLink ? <div>{renderRedirectButton()}</div> : null}

        {/* LINK */}
      </div>
    </div>
  );
}

export default Redirect2;
